module.exports = __webpack_public_path__ + "static/chipbrain-fad41bb2580a236678cb373332ec4e02.png";